export default __webpack_public_path__ + "static/media/servo.1f16fb7c.svg";